import React from 'react';
import SitePage, { SectionHeader } from './SiteChrome';

// Approach (spec §6): See / Build / Stay at full length — the Home copy
// expanded to three short paragraphs each, same language, plus the quote band.

const STEPS = [
  {
    name: 'See',
    paras: [
      'Start with how you want to be seen. Not the logo, not the site — the impression. Every engagement begins there, because every decision after it hangs on that answer.',
      'Then we look at what exists: mark, site, photos, words, channels. We name what holds together and what doesn\u2019t, in plain language, with examples pulled from your own presence.',
      'What you get is a short, honest read — what to keep, what to fix, what to retire. No forty-slide audit. Just the picture, seen clearly.',
    ],
  },
  {
    name: 'Build',
    paras: [
      'Build the system: identity, site, photography, copy, channels. Not five vendors\u2019 versions of your brand — one system, built by the hands that will keep it.',
      'One point of view, one set of standards. The mark informs the site; the site sets the photography; the photography carries the campaigns; the copy sounds the same everywhere it appears.',
      'We work in the open as it comes together, and nothing ships until it reads, looks, and works like one company made it. Because one did.',
    ],
  },
  {
    name: 'Stay',
    paras: [
      'Stay on for updates, campaigns, and care. A presence is maintained, not launched — the site that never changes is the site that slowly stops being true.',
      'That means the small work, done steadily: fixes and improvements, monthly content from the library we built, ad flights that match the season, copy that keeps pace with the business.',
      'You get the same studio that built the system minding it — so it never drifts back into patchwork.',
    ],
  },
];

export default function Approach() {
  return (
    <SitePage>
      <section className="ac-section">
        <div className="ac-lightwash" aria-hidden="true" />
        <div className="ac-wrap" style={{ position: 'relative' }}>
          <SectionHeader kicker="Approach" title="How we work." />
          {/* Vertical timeline: the line draws down through See/Build/Stay as
              you scroll; each step's paragraphs stagger in. */}
          <div className="ac-timeline">
            {STEPS.map((s) => (
              <div className="ac-tstep" key={s.name}>
                <h3 className="ac-reveal">{s.name}<em>.</em></h3>
                {s.paras.map((p, i) => (
                  <p className="ac-reveal" style={{ '--d': `${0.1 + i * 0.12}s` }} key={i}>{p}</p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ac-section ac-section-wash ac-quote-band">
        <span className="ac-amp-watermark" aria-hidden="true">&amp;</span>
        <div className="ac-wrap ac-reveal">
          <blockquote className="ac-quote" style={{ margin: 0 }}>
            One studio. The whole presence.
          </blockquote>
        </div>
      </section>
    </SitePage>
  );
}
